import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {FOCUS_BLUE, WHITE, CHARCOAL} from '../../../shared/style/colors';
import {LAPTOP, PHONE, TABLET} from '../../../shared/style/breakpoints';
import SimpleButton from '../../../shared/library/buttons/base/simple';
import {BASE_TEXT, FONTS, WEIGHT} from '../../../shared/style/typography';
import RequestDemo from '../../../bundles/enterprise/components/request-demo';
import {ALPHA} from '../../../shared/style/color-utils';

const Container = glamorous.div({
  margin: 'auto',
  background: CHARCOAL,
  [PHONE]: {
    padding: '0 20px'
  }
});

const Title = glamorous.div({
  ...BASE_TEXT,
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontWeight: WEIGHT.ULTRA_BLACK,
  fontSize: 40,
  textAlign: 'center',
  paddingTop: 50,
  lineHeight: '50px',
  marginBottom: 35,
  color: WHITE,
  [TABLET]: {
    margin: 'auto',
    marginBottom: 50
  },
  [PHONE]: {
    fontSize: 28,
    lineHeight: '43px',
    textAlign: 'center',
    margin: 'auto',
    marginBottom: 35
  },
  [LAPTOP]: {
    fontSize: 34
  }
});

const LearnMore = glamorous(SimpleButton)({
  width: 191,
  height: 58,
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontSize: 20,
  fontWeight: WEIGHT.ULTRA_BOLD,
  lineHeight: '39px',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: ALPHA(FOCUS_BLUE, 0.9),
    border: `1px solid ${FOCUS_BLUE}`
  },
  ':focus': {
    color: WHITE
  },
  [LAPTOP]: {
    padding: 0
  },
  [PHONE]: {
    width: 'auto',
    padding: 0,
    margin: 'auto'
  }
}).withComponent('a');

const ButtonContainer = glamorous.div({
  display: 'flex',
  paddingBottom: 40,
  justifyContent: 'center',
  [PHONE]: {
    display: 'block',
    height: 137,
    margin: 'auto'
  }
});

const GetStarted = ({title}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <ButtonContainer>
        <LearnMore href={`/enterprise`}>Learn More</LearnMore>
        <RequestDemo
          eventProperties={{
            index: 1,
            sectionName: 'SignupHeader'
          }}
          extraStyle={{
            color: WHITE,
            background: CHARCOAL,
            fontFamily: FONTS.CEREBRI_SANS_PRO,
            fontSize: 20,
            fontWeight: WEIGHT.ULTRA_BOLD,
            width: 239,
            height: 58,
            marginLeft: 31,
            border: `1px solid ${WHITE}`,
            borderRadius: 4,
            padding: '13px 21px 15px 20px',
            '&:hover': {
              background: ALPHA(WHITE, 0.1),
              border: `1px solid ${WHITE}`
            },
            '&:focus': {
              border: `1px solid ${FOCUS_BLUE}`
            },
            [PHONE]: {
              margin: '18px 0 0'
            }
          }}
        />
      </ButtonContainer>
    </Container>
  );
};

GetStarted.propTypes = {
  title: PropTypes.string
};

export default GetStarted;
